import { SxProps } from '@mui/material';
import { black, grey7, grey8, red2, red3 } from 'app/components/ThemeProvider/colors';

export const inputInfo: SxProps = {
  fontFamily: 'Yelo',
  fontSize: '14px',
  mb: '8px',
  color: grey7,

  '@media screen and (max-height: 864px)': {
    mb: '6px',
  },
};

export const infoText: SxProps = {
  fontFamily: 'Yelo',
  fontSize: '26px',
  mb: '12px',
  fontWeight: '600',
};
export const descText: SxProps = {
  fontFamily: 'Yelo',
  fontSize: '17px',
  mb: '22px',
  fontWeight: '400',
  color: grey8,
};

export const warningBox: SxProps = {
  display: 'flex',
  alignItems: 'center',
  p: '14px 16px',
  border: `1px solid ${red2}`,
  borderRadius: '10px',
  background: red3,
  mt: '28px',

  '@media screen and (max-height: 864px)': {
    mt: '24px',
  },
};

export const errorText: SxProps = {
  fontFamily: 'Yelo',
  fontSize: '14px',
  color: black,
};

export const btnBox: SxProps = {
  display: 'flex',
  flexDirection: 'column',
};
